export default __webpack_public_path__ + "static/media/대구.cf725d79.svg";